require("-!/Users/11th.feb/Documents/11thfeb/11thfeb/myproject/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!style-loader!css-loader!less-loader!/Users/11th.feb/Documents/11thfeb/11thfeb/myproject/node_modules/font-awesome-webpack/font-awesome-styles.loader.js!/Users/11th.feb/Documents/11thfeb/11thfeb/myproject/src/theme/font-awesome.prod.config.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome-webpack/index.loader.js!./src/theme/font-awesome.prod.config.js
 ** module id = 324
 ** module chunks = 0
 **/